// @givmo/app-charity — the auth-route path constants (single source of truth for the auth surface).
//
// The unauthenticated screens live as siblings off the root (NOT behind the authenticated layout).
// Keeping the paths here means the router, the screens, and any post-login redirect target all agree.

export const AUTH_ROUTES = {
  /** Sign-in main chooser (email + Google + Microsoft). The guard redirects here when signed out. */
  loginHome: '/login-home',
  /** Email/password sign-in form. */
  signIn: '/sign-in',
  /**
   * Sign-up chooser (email + Google + Microsoft). Where the guard forwards a signed-out caller of
   * an emailed deep link — the outreach email's `/claim/<id>` (D-CP-64) and the admin-invite
   * email's `/invites/accept?token=…` (D-CP-65); neither email links here directly.
   */
  signUp: '/sign-up',
  /** Email/password + name sign-up form — the chooser's email path, as its own step. */
  signUpEmail: '/sign-up/email',
  /** Backend-OTP email verification (after sign-up). */
  verifyEmail: '/verify-email',
  /**
   * The way back in for someone whose company locks how they sign in (AS-WEB26): every door's "Lost
   * access to your company sign-in?" opens it, Board's director door's included. A signed-out page.
   */
  lostCompanyAccess: '/lost-company-access',
  /**
   * The organization door's step (AS-WEB30): every door's "Continue with Organization SSO" opens it.
   * Its return page is `@givmo/passkeys`' `ORGANIZATION_SSO_CALLBACK_PATH`, an operator contract.
   */
  organizationSso: '/sso',
} as const;

/**
 * The default post-auth landing: the ROOT, which never renders — it re-runs the landing rule
 * (`router/console-landing.tsx`) and replaces itself with wherever this person belongs (CPA-WEB40).
 * Every sign-in surface that has no `redirect` to honour lands here; none of them names a page.
 */
export const DEFAULT_AUTHENTICATED_ROUTE = '/';
